import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0c472ef8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "hidden sm:block" }
const _hoisted_2 = { class: "flex justify-content-between mx-auto wp1200 py-4" }
const _hoisted_3 = { class: "text-2xl font-bold" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_map-import font-bold" }, null, -1))
const _hoisted_5 = { class: "wp1200 p-0" }
const _hoisted_6 = { class: "flex gap-2" }
const _hoisted_7 = { class: "list" }
const _hoisted_8 = ["onClick", "onKeyup"]
const _hoisted_9 = { class: "flex" }
const _hoisted_10 = { class: "flex flex-column gap-2" }
const _hoisted_11 = { class: "text-primary font-semibold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_ListFilters = _resolveComponent("ListFilters")!
  const _component_Divider = _resolveComponent("Divider")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.getTitle(_ctx.$route.params.feature as string)), 1),
        (_ctx.$route.name === 'InfoList')
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'InfoMap' }))),
              class: "flex align-items-center gap-2 border-none bg-white text-primary font-bold text-lg cursor-pointer"
            }, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t("bikes.show_map")), 1),
              _hoisted_4
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_ListFilters, {
        onAddressChange: _ctx.setAddress,
        onClear: _ctx.clearAddress,
        onMapMode: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push({ name: 'InfoMap' })))
      }, {
        types: _withCtx(() => [
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filters, (filter, index) => {
              return (_openBlock(), _createBlock(_component_MultiSelect, {
                key: index,
                modelValue: _ctx.selectedFilters[filter.key],
                "onUpdate:modelValue": ($event: any) => ((_ctx.selectedFilters[filter.key]) = $event),
                filter: "",
                display: "chip",
                placeholder: _ctx.$t('info.filters.' + filter.key),
                options: filter.data,
                class: "sm:w-16rem",
                optionLabel: "title",
                optionValue: "title",
                "empty-message": _ctx.$t('news.no_provider'),
                "empty-filter-message": _ctx.$t('global.no_hits')
              }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder", "options", "empty-message", "empty-filter-message"]))
            }), 128))
          ])
        ]),
        _: 1
      }, 8, ["onAddressChange", "onClear"]),
      _createElementVNode("div", _hoisted_7, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredItems, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item.id
          }, [
            _createElementVNode("div", {
              tabindex: "0",
              class: "flex justify-content-between align-items-center gap-1 p-3 pt-4 px-3 cursor-pointer",
              onClick: ($event: any) => (
            _ctx.$router.push({
              name: 'InfoById',
              params: { id: item.id },
            })
          ),
              onKeyup: _withKeys(($event: any) => (
            _ctx.$router.push({
              name: 'InfoById',
              params: { id: item.id },
            })
          ), ["enter"])
            }, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("span", _hoisted_11, _toDisplayString(item.name), 1)
                ])
              ]),
              (_ctx.infoFeature)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: _normalizeClass([_ctx.infoFeature.icon, "text-3xl"])
                  }, null, 2))
                : _createCommentVNode("", true)
            ], 40, _hoisted_8),
            _createVNode(_component_Divider, { class: "m-0" })
          ]))
        }), 128))
      ])
    ])
  ], 64))
}